import { render } from "./UiSelect.vue?vue&type=template&id=4c54cc86&ts=true"
import script from "./UiSelect.vue?vue&type=script&lang=ts"
export * from "./UiSelect.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__